import moment from "moment";
import Status from "../../core/blocks/Status";
import { useTranslation } from "react-i18next";
import { useDateFormatter } from "../../../i18n/useDateFormatter";

const PLAN_STATUSES = {
  planning: {
    label: ($) => $.merchandising["Planning"],
    color: "#a78dc2",
    subLabel: (t, fmt, { due }) => t(($) => $.merchandising["due {when}"], { when: moment(due).fromNow() }),
  },
  planned: {
    label: ($) => $.merchandising["Planned"],
    color: "#a78dc2",
    subLabel: (t, fmt, { start }) => t(($) => $.merchandising["starts {when}"], { when: moment(start).fromNow() }),
  },
  executing: {
    label: ($) => $.merchandising["Active"],
    color: "#0fc398",
    subLabel: (t, fmt, { end }) => t(($) => $.merchandising["ends {when}"], { when: moment(end).fromNow() }),
  },
  finished: {
    label: ($) => $.merchandising["Complete"],
    color: "#ff7bac",
    subLabel: (t, fmt, { end }) =>
      t(($) => $.merchandising["finished on {date}"], { date: fmt.format(moment(end).toDate()) }),
  },
  // Product Launch States
  preparing: {
    label: ($) => $.merchandising["Preparing"],
    color: "#a78dc2",
    subLabel: (t, fmt, dates) => {
      const difference = moment(dates.start).endOf("day").diff(moment().startOf("day"), "days");
      return t(($) => $.merchandising["days until launch"], { count: difference });
    },
  },
  introduced: {
    label: ($) => $.merchandising["Introduced"],
    color: "#0fc398",
    subLabel: (t, fmt, dates) =>
      t(($) => $.merchandising["days remaining"], {
        count: moment(dates.end).diff(moment(), "days"),
      }),
  },
  launched: {
    label: ($) => $.merchandising["Launched"],
    color: "#ff7bac",
    subLabel: (t) => t(($) => $.merchandising["Launch complete"]),
  },
};

const PlanStatus = ({ status, due, start, end, ...props }) => {
  const { t } = useTranslation(["merchandising"]);
  const fmt = useDateFormatter("monthDay");
  const { label, color, subLabel } = PLAN_STATUSES?.[status] ?? PLAN_STATUSES.planning;
  return <Status color={color} label={t(label)} subLabel={subLabel(t, fmt, { due, start, end })} {...props} />;
};

export default PlanStatus;
